import { BASE_URL } from 'config';
import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import Box from "@mui/material/Box";

const PersonalInfoEdit = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "", avatar: "" });
  const [avatarPreview, setAvatarPreview] = useState("");
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  useEffect(() => {
    if (open) {
      fetchProfile();
      setErrors({});
      setTouched({});
    }
    // eslint-disable-next-line
  }, [open]);

  const fetchProfile = async () => {
    setLoading(true);
    const token = localStorage.getItem("user-token");
    try {
      const response = await fetch(BASE_URL + "/manager/profile", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await response.json();
      setProfile(data.data);
      setForm({
        name: data.data.name || "",
        email: data.data.email || "",
        phone: data.data.phone || "",
        avatar: data.data.avatar || "",
      });
      setAvatarPreview(
        data.data.avatar ? `https://back.al-balad.sa/uploads/users/avatars/${data.data.avatar}` : ""
      );
    } catch (error) {
      setProfile(null);
    } finally {
      setLoading(false);
    }
  };

  const validateForm = (fields = form) => {
    const newErrors = {};
    if (!fields.name.trim()) newErrors.name = "الاسم مطلوب";
    if (!fields.email.trim()) {
      newErrors.email = "البريد الإلكتروني مطلوب";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) {
      newErrors.email = "صيغة البريد الإلكتروني غير صحيحة";
    }
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors(validateForm({ ...form, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({ ...prev, [name]: true }));
    setErrors(validateForm(form));
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm((prev) => ({ ...prev, avatar: file }));
      setAvatarPreview(URL.createObjectURL(file));
    }
  };

  const isFormValid = Object.keys(validateForm(form)).length === 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>تعديل البيانات الشخصية</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
            <CircularProgress />
          </Box>
        ) : (
          <Box display="flex" flexDirection="column" gap={3} mt={1}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
              <Avatar src={avatarPreview} sx={{ width: 80, height: 80, mb: 1 }} />
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="avatar-upload"
                type="file"
                onChange={handleAvatarChange}
              />
              <label htmlFor="avatar-upload">
                <IconButton color="primary" component="span">
                  <PhotoCamera />
                </IconButton>
              </label>
            </Box>
            <TextField
              label="الاسم"
              name="name"
              value={form.name}
              onChange={handleChange}
              onBlur={handleBlur}
              fullWidth
              variant="outlined"
              error={!!errors.name && touched.name}
              helperText={touched.name && errors.name ? errors.name : ""}
            />
            <TextField
              label="البريد الإلكتروني"
              name="email"
              value={form.email}
              onChange={handleChange}
              onBlur={handleBlur}
              fullWidth
              variant="outlined"
              error={!!errors.email && touched.email}
              helperText={touched.email && errors.email ? errors.email : ""}
            />
            <TextField
              label="رقم الهاتف"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              fullWidth
              variant="outlined"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ color: "white !important", backgroundColor: "red !important", border: "none" }}
        >
          إلغاء
        </Button>
        <Button
          color="primary"
          variant="contained"
          sx={{ color: "white !important" }}
          disabled={!isFormValid}
        >
          حفظ التعديلات
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PersonalInfoEdit;
